/**
 * Project: Aniatek
 * Author: Carlos A. Loaiza | Connect & Launch
 * Tel: +52 (667) 247 - 6316
 * Intellectual Property: All rights reserved (c) 2026
 */

<template>
  <div class="container-white">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ContainerWhite',
}
</script>

<style scoped>
html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
}

.container-white {
  background-color: #FFFFFF;
  border-radius: 10px;
  box-shadow: 0px 3px 6px #00000029;
  width: 100%;
  height: calc(90vh - 100px);
  overflow-y: auto;
}

</style>